import moment from "moment";

export const formatDate = (value) =>
  value ? moment(value).format("YYYY-MM-DD HH:mm") : "-";

export const parseJSONText = (value) => {
  if (!value || typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
